import { observer } from 'mobx-react';
import React from 'react'
import { ReactComponent as CheckRight } from '../../svg/chevron-right.svg'
import { ReactComponent as CheckLeft } from '../../svg/chevron-left.svg'

@observer
class ScrollArrow extends React.Component {

  handleScroll(e){
    e.preventDefault()
    const { scrollPosition, scrollClass, backwards, parentClass } = this.props
    const parent = document.querySelector('.' + parentClass)
    const scroll = document.querySelector('.' + scrollClass.split(' ').join('.'))
    if(!scroll || !parent){
      return
    }
    const parentWidth = parent.clientWidth
    let newPos = scrollPosition + parentWidth / 2
    if(backwards){
      newPos = scrollPosition - parentWidth / 2
    }
    if(newPos > scroll.scrollWidth){
      scroll.scroll(scroll.scrollWidth, 0)
    }
    scroll.scroll(newPos, 0)
  }

  render(){
    const { backwards, style } = this.props
    let styling = {}
    if(style){
      styling = {
        ...style
      }
    }
    const className = backwards ? 'scroll-arrow backwards' : 'scroll-arrow forward'
    return (
      <div style={styling} className={className} onClick={this.handleScroll.bind(this)}>
        {
          backwards ? (
            <CheckLeft className='scroll-arrow__icon' />
          )
          :
          (
          <CheckRight className='scroll-arrow__icon' />
          )
        }
      </div>
    )
  }

}

export default ScrollArrow